import { createSelector } from 'reselect'

import { selectState } from 'utils/redux'

export const classificationSelector = createSelector(
  (state) => state,
  (state) => selectState(state, 'classifications')
)
